<template>
  <div class="base-header">
    <div>
      <div class="title">
        <img
          src="../../deps/public/solplanet-logo.png"
          height="40"
          alt=""
          @click="$router.push({ name: 'OnlineClaim' })"
        />
        <i
          :class="showmenu ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          @click="showMenu"
        ></i>
        <el-dropdown style="float:right;">
          <div class="el-dropdown-link">
            <template v-for="m in dropdown">
              <a
                :key="m.key"
                href="javascript:;"
                :class="{ actived: lang == m.key }"
                v-if="lang == m.key"
                >{{ $i18n.t('language') }}</a
              >
            </template>
            <i class="el-icon-orange el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="header-drop">
            <el-dropdown-item
              v-for="m in dropdown"
              :key="m.value"
              @click.native="m.fn()"
              >{{ m.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="banner">
      <!-- <span class="phone-login" v-if="!isLogin" @click="$router.push({ name: 'login' })">Log ln</span> -->
      <div style="margin-left:19%;padding-top:140px">
        <div style="text-align: left;">
          <p>
            <span
              style="width: 1006px;height: 114px;font-size: 48px;font-family: HelveticaNeue-Bold, HelveticaNeue;font-weight: bold;color: #FFFFFF;line-height: 58px;"
            >
              {{ $i18n.t('banner1') }}</span
            >
          </p>
          <p>
            <span
              style="width: 1006px;height: 114px;font-size: 48px;font-family: HelveticaNeue-Bold, HelveticaNeue;font-weight: bold;color: #FFFFFF;line-height: 58px;"
            >
              {{ $i18n.t('banner2') }}</span
            >
          </p>
          <p style="margin-top: 30px;">
            <span
              style="width: 282px;height: 36px;font-size: 30px;font-family: HelveticaNeue-Medium, HelveticaNeue;font-weight: 500;color: #FFFFFF;line-height: 37px;"
            >
              {{ $i18n.t('banner3') }}</span
            >
          </p>
        </div>
      </div>
    </div>
    <div class="phoneMenu" v-if="showmenu">
      <div v-for="m in phoneMenu" :key="m.label">
        <div class="tilte">
          {{ m.label }}
          <i
            @click="m.showChild = !m.showChild"
            :class="m.showChild ? 'el-icon-minus' : 'el-icon-plus'"
          ></i>
        </div>
        <div v-show="m.showChild" class="lists">
          <div v-for="n in m.children" :key="n.label" @click="goRouter(n.href)">
            {{ n.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    isLogin() {
      return sessionStorage.getItem('userData')
    },
    links() {
      let link = [
        {
          name: 'OnlineClaim',
          label: 'Online Claim'
        }
      ]
      if (this.$route.path.indexOf('userSetting') >= 0) {
        link = [
          {
            name: 'Ordermanagement',
            label: 'Order management'
          },
          {
            name: 'Emailsetting',
            label: 'Email setting'
          },
          {
            name: 'Passwordsetting',
            label: 'Password setting'
          },
          {
            name: 'Accountsetting',
            label: 'Account setting'
          }
        ]
      }
      return link
    }
  },
  data() {
    return {
      lang: '',
      userName: 'English',
      showmenu: false,
      dropdown: [
        // {
        //   key: 'zh',
        //   label: this.$i18n.t('chinese'),
        //   fn: () => {
        //     this.changeL('zh')
        //   }
        // },
        {
          key: 'en',
          label: this.$i18n.t('english'),
          fn: () => {
            this.changeL('en')
          }
        },
        {
          key: 'polish',
          label: this.$i18n.t('polish'),
          fn: () => {
            this.changeL('polish')
          }
        },
        {
          key: 'spanish',
          label: this.$i18n.t('spanish'),
          fn: () => {
            this.changeL('spanish')
          }
        },
        {
          key: 'turkish',
          label: this.$i18n.t('turkish'),
          fn: () => {
            this.changeL('turkish')
          }
        },
        {
          key: 'dutch',
          label: this.$i18n.t('dutch'),
          fn: () => {
            this.changeL('dutch')
          }
        },
        {
          key: 'hungary',
          label: this.$i18n.t('hungary'),
          fn: () => {
            this.changeL('hungary')
          }
        },
        {
          key: 'zhtw',
          label: this.$i18n.t('zhtw'),
          fn: () => {
            this.changeL('zhtw')
          }
        },
        {
          key: 'ptbr',
          label: this.$i18n.t('ptbr'),
          fn: () => {
            this.changeL('ptbr')
          }
        },
        {
          key: 'germany',
          label: this.$i18n.t('germany'),
          fn: () => {
            this.changeL('germany')
          }
        },
        {
          key: 'french',
          label: this.$i18n.t('french'),
          fn: () => {
            this.changeL('french')
          }
        },
        {
          key: 'italian',
          label: this.$i18n.t('italian'),
          fn: () => {
            this.changeL('italian')
          }
        }
      ],
      phoneMenu: [
        {
          label: 'Warranty',
          showChild: true,
          children: [
            {
              href: 'OnlineClaim',
              label: 'Online Claim'
            }
          ]
        },
        {
          label: 'Personal Center',
          showChild: false,
          children: [
            {
              label: 'Email Setting',
              href: 'Emailsetting'
            },
            {
              label: 'Password',
              href: 'Passwordsetting'
            },
            {
              label: 'Account',
              href: 'Accountsetting'
            },
            {
              label: 'Order Management',
              href: 'Ordermanagement'
            }
          ]
        }
      ]
    }
  },
  methods: {
    goRouter(href) {
      this.showmenu = false
      document.querySelector('html').style = ''
      this.$router.push({ name: href })
    },
    showMenu() {
      if (this.showmenu) {
        document.querySelector('html').style = ''
        this.showmenu = false
      } else {
        document.querySelector('html').style = 'overflow:hidden'
        this.showmenu = true
      }
    },
    loginout() {
      sessionStorage.clear()
      window.isLogin = null
      this.$router.push({ name: 'login' })
    },
    changeL(lang) {
      const prevLang = location.hash.split('/')[1]
      location.href = location.href.replace(prevLang, lang)
      setTimeout(() => {
        location.reload()
      })
    },
    jumpOffice(lang) {
      if (this.lang === 'zh') {
        location.href = 'https://www.aiswei-tech.com/'
      } else {
        location.href = 'https://en.aiswei-tech.com/'
      }
    }
  },
  created() {
    document.title = this.$i18n.t('documentTitle')
    this.lang = location.hash.split('/')[1]
  },
  mounted() {
    if (!this.isLogin) {
      this.phoneMenu.splice(1, 1)
    }
  }
}
</script>
<style lang="stylus">
.isPC {
  .phone-login {
    display: none;
  }

  .w1200 .page-transition {
    min-height: 500px;
  }

  .header-drop {
    top: 80px !important;
  }
}


.base-header {
  width: 100%;
  background: #fff;

  .title {
    height: 90px;
    line-height: 90px;
    padding-left: 60px;
    padding-right: 30px;

    .el-icon-orange {
      font-size 24px
      position relative
      top 4px
    }
    & > i {
      display: none;
    }

    img {
      margin-top: 25px;
      max-width: 239px;
      max-height: 64px;
    }

    a {
      margin-left: 15px;
      font-size: 18px;
      color: #333;
    }

    .logout {
      float: right;
      margin-right: 15px;
      border-right: 1px solid #D8D8D8;

      .el-button {
        background: linear-gradient(270deg, #ab499e 0%, #ff4f4f 100%);
        color: #fff;
        height: 30px;
        line-height: 30px;
        border-radius: 30px;
        padding: 0;
        min-width: 120px;
      }

      img {
        margin: 0 32px;
        position: relative;
        top: 10px;
        cursor: pointer;
      }
    }

    .actived {
      color: #3E3E3E;
      font-weight: bold;
    }
  }

  .banner {
    height: 385px;
    background: url('../../deps/public/base-banner.png') no-repeat center center;
    background-size: cover;
  }

  .links {
    border-bottom: 1px solid #dadada;
    box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);

    .w1200 {
      overflow: hidden;
      line-height: 36px;
      padding: 0;

      & > span {
        font-size: 24px;
        font-weight: normal;
        color: rgba(153, 153, 153, 1);
      }
    }

    .ul-btn {
      float: right;
      width: 60%;

      .el-button {
        color: #333333;
        font-size: 18px;
        margin-right: 4%;
        padding: 2%;
        font-weight: bold;
        border: 0;
        margin-left: 0;

        &:hover {
          color: #FF4F4F;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .actived {
        color: #FF4F4F;
        position: relative;

        &:after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          height: 6px;
          width: 85%;
          left: 7%;
          background: linear-gradient(270deg, #AB499E 0%, #FF4F4F 100%);
        }
      }
    }
  }
}

.isPhone {
  .base-header {
    .title {
      height: 46px;
      line-height: 46px;
      padding: 0 16px;

      & > i {
        display: block;
        font-size: 24px;
        float: right;
        margin-top: 10px;
      }

      .el-icon-orange {
        margin-right 8px
      }
      img {
        height: 20px;
        margin-top: 13px;
      }

      a, .logout {
        display: none;
      }
    }

    .links {
      display: none;
    }

    .banner {
      height: 440px;
      background: url('../../deps/public/mobie-background.png') no-repeat center center;
      background-size: cover;
      & > div:first-child {
        margin: 10px!important;
        padding-top: 80px!important;
        span {
          font-size: 2rem!important;
        }
      }
      .phone-login {
        position: absolute;
        left: 20px;
        width: 90px;
        height: 24px;
        border-radius: 34px;
        border: 1px solid #FFFFFF;
        font-size: 12px;
        color: #fff;
        line-height: 24px;
        display: block;
        text-align: center;
        top: 350px;
      }
    }

    .phoneMenu {
      position: fixed;
      top: 45px;
      left: 0;
      width: 100%;
      height: calc(100% - 45px);
      background: #fff;
      box-shadow: 4px -2px 10px 0px rgba(169, 169, 169, 0.2);
      z-index: 999;

      & > div {
        .tilte {
          padding: 16px 20px;
          border-bottom: 1px solid #D8D8D8;

          i {
            font-size: 24px;
            float: right;
          }
        }

        .lists {
          background: #ECECEC;

          div {
            padding: 16px 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/baseHeader/index.vue